module.exports = __webpack_public_path__ + "a87e98b37d0992b7aedb69b3c6a53bad.svg";